import { create } from 'zustand';
import type { CouponListFilters } from '../types';

interface FiltersState extends CouponListFilters {
  setFilter: <K extends keyof CouponListFilters>(key: K, value: CouponListFilters[K]) => void;
  reset: () => void;
}

/** Module-level store (Products convention) so filters survive list → detail → back. */
export const useCouponFilters = create<FiltersState>((set) => ({
  setFilter: (key, value) => set({ [key]: value || undefined }),
  reset: () => set({ search: undefined, status: undefined }),
}));
